export default __webpack_public_path__ + "static/media/picto-logout.3945fe94.svg";